module.exports = __webpack_public_path__ + "static/floral@1.5x-7bcf11b35b413cf82c28e4f7aba514d9.png";